import MonacoEditor, { loader } from '@monaco-editor/react';
import * as monaco from 'monaco-editor';
import { registerTakeshapeTheme } from '../monaco-theme.js';

loader.config({ monaco });

// Register the TakeShape custom theme
registerTakeshapeTheme(monaco);

export default MonacoEditor;
